<template>
    <b-card
        :title="$t('Component(ProductMaterialMixtureCategorySelector):categories')"
        border-variant="light"
    >
        <b-row v-if="readOnly">
            <b-col md="6">
                <h6>{{ $t('Component(CompositionSubstance):material-category') }}</h6>
                <div>{{ formatCategoryList(materialCategoryTitles) }}</div>
            </b-col>
            <b-col md="6">
                <h6>{{ $t('Component(CompositionSubstance):mixture-category') }}</h6>
                <div>{{ formatCategoryList(mixtureCategoryTitles) }}</div>
            </b-col>
        </b-row>
        <b-row v-else>
            <b-col md="6">
                <MaterialCategory
                    :value="materialCategoryValue"
                    :config="{data: materialCategories}"
                    @input="onMaterialCategoryChange"
                />
            </b-col>
            <b-col md="6">
                <MixtureCategory
                    :value="mixtureCategoryValue"
                    :config="{data: mixtureCategories}"
                    @input="onMixtureCategoryChange"
                />
            </b-col>
        </b-row>
    </b-card>
</template>

<script>
import { BCard, BCol, BRow } from 'bootstrap-vue'
import substanceDictionaries from '@core/mixins/substance-dictionaries'
import {
    MaterialCategory,
    MixtureCategory,
} from '@/views/product/components/product-card/composition/components'

export default {
    components: {
        BCard,
        BCol,
        BRow,
        MaterialCategory,
        MixtureCategory,
    },
    mixins: [substanceDictionaries],
    props: {
        materialCategoryIds: {
            type: Array,
            default() {
                return []
            },
        },
        mixtureCategoryIds: {
            type: Array,
            default() {
                return []
            },
        },
        readOnly: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        materialCategoryValue() {
            return this.toTreeSelectValue(this.materialCategoryIds)
        },
        mixtureCategoryValue() {
            return this.toTreeSelectValue(this.mixtureCategoryIds)
        },
        materialCategoryTitles() {
            return this.resolveCategoryTitles(this.materialCategoryIds, this.materialCategories)
        },
        mixtureCategoryTitles() {
            return this.resolveCategoryTitles(this.mixtureCategoryIds, this.mixtureCategories)
        },
    },
    created() {
        this.initSubstanceDictionaries()
    },
    methods: {
        toTreeSelectValue(value) {
            return this.toIdList(value).map(id => ({ id, title: '' }))
        },
        toIdList(value) {
            if (!Array.isArray(value)) {
                return []
            }

            return value
                .map(item => (item && typeof item === 'object' ? item.id : item))
                .filter(id => id !== null && id !== undefined && id !== '')
        },
        onMaterialCategoryChange(value) {
            this.$emit('change', {
                materialCategoryIds: this.toIdList(value),
                mixtureCategoryIds: this.toIdList(this.mixtureCategoryIds),
            })
        },
        onMixtureCategoryChange(value) {
            this.$emit('change', {
                materialCategoryIds: this.toIdList(this.materialCategoryIds),
                mixtureCategoryIds: this.toIdList(value),
            })
        },
        resolveCategoryTitles(value, categories) {
            return this.toIdList(value)
                .map(id => this.findCategoryById(id, categories))
                .filter(category => category)
                .map(category => category.title || category.code || category.id)
        },
        findCategoryById(id, categories) {
            const idString = String(id)
            const directCategory = categories.find(category => String(category.id) === idString)
            if (directCategory) {
                return directCategory
            }

            return categories
                .map(category => this.findCategoryById(id, category.children || []))
                .find(category => category) || null
        },
        formatCategoryList(categories) {
            return categories.length ? categories.join(', ') : '-'
        },
    },
}
</script>
